const data = {
  navigation: {
    logoUrl: "img/logo-color-small.png",
    menu: [
      {
        id: "0",
        item: "Inicio",
        link: "top"
      },
      {
        id: "1",
        item: "Quienes somos",
        link: "about"
      },
      {
        id: "2",
        item: "Servicios",
        link: "services"
      },
      {
        id: "3",
        item: "Preguntas frecuentes",
        link: "faq"
      },
      {
        id: "4",
        item: "Contacto",
        link: "contact"
      }
    ]
  },
  hero: {
    title: "Recolección responsable, entorno confortable",
    imageUrl: "img/desecho-residuos.png",
    phrase: "¡Bienvenido a AKIGREEN!",
    phrase2: "Tu socio en la gestión de residuos biocontaminados",
    ctaText: "Envía un mensaje",
    ctaUrl: "https://wa.link/unxfc0"
  },
  about: {
    value: "5",
    indicator: "diferentes industrias y clientes",
    title: "Gestión de estudios y capacitaciones junto a eliminación y manejo de residuos sólidos biocontaminados",
    description: "Somos una empresa con personal altamente capacitado y experimentado, donde ofrecemos un servicio eficiente y sostenible a nuestros clientes mientras protegemos la naturaleza, almacenamiento e industria. Nos comprometemos con la conservación ambiental y promovemos prácticas responsables en todas las operaciones."
  },
  services: {
    title: "Brindamos diferentes servicios comprometidos con el medio ambiente. Nuestros servicios se enfocan en el manejo y recolección de residuos sólidos de tu centro de salud garantizando la seguridad y normativas sanitarias. Además de realizar estudios viales y capacitaciones sanitarias.",
    image: "img/doctor-removiendo-guantes.png",
    items: [
      {
        id: 1,
        title: "Recojo de residuos sólidos biocontaminados",
        description: "Nos encargamos del recojo, procesamiento y eliminación de los residuos sólidos biocontaminados.",
        iconUrl: "img/residuos-toxicos.png"
      },
      {
        id: 2,
        title: "Estudio vial",
        description: "Realizamos la asesoría para identificar, evaluar y mitigar los problemas que ocurran sobre la vialidad generada por la construcción y operación de un nuevo proyecto.",
        iconUrl: "img/cono-de-trafico.png"
      },
      {
        id: 3,
        title: "Capacitaciones sanitarias",
        description: "Dirigido al personal de tu establecimiento con el fin de concientizar sobre el manejo técnico y lo que engloba la eliminación de residuos sólidos biocontaminados.",
        iconUrl: "img/conferencia.png"
      },
      {
        id: 4,
        title: "Declaraciones en plataforma SIGERSOL",
        description: "Te ayudamos en la Declaración de los Manifiestos, Declaración Anual sobre Minimización y Gestión de Residuos Sólidos No Municipales a SIGERSOL. Evita pagar multa de hasta 3 UIT (S/. 15 450).",
        iconUrl: "img/registro.png"
      },
      {
        id: 5,
        title: "Estudio de impacto ambiental",
        description: "Realizamos el estudio técnico, objetivo y de carácter interdisciplinario llevado a cabo por nuestro equipo de especialistas, a fin de ejecutar una descripción detallada del proyecto.",
        iconUrl: "img/el-planeta-tierra.png"
      }
    ]
  },
  how: {
    title: "Contamos con diferentes licencias que nos permiten y ratifican la seguridad y cumplimiento de nuestro trabajo",
    permits: [
      {
        logoUrl: "img/minam.png"
      },
      {
        logoUrl: "img/mtc-logotipo.png"
      },
      {
        logoUrl: "img/Mml-bn.png"
      }
    ],
    ctaTitle: "¿Estás interesado en alguno de nuestros servicios?",
    ctaText: "Agenda una cita",
    ctaUrl: "https://wa.link/unxfc0",
  },
  clients: {
    items: [
      {
        logoUrl: ""
      },
      {
        logoUrl: ""
      },
      {
        logoUrl: ""
      }
    ]
  },
  faq: {
    title: "En esta sección encontrarás respuestas a preguntas frecuentes",
    imageUrl: "img/doctores-tablet.jpg",
    items: [
      {
        id: 1,
        question: "¿Qué tipo de residuos biocontaminados tratan?",
        answer: "Tratamos la eliminación y manejo de residuos biocontaminados generados en hospitales, clínicas, laboratorios y centros de salud, estos incluyen jeringas, punzocortantes, material quirúrgico.",
        isOpen: false
      },
      {
        id: 2,
        question: "¿Qué es SIGERSOL?",
        answer: "Sistema de Información para la Gestión de Residuos Sólidos es una plataforma creada por el MINAM para llevar control de los residuos generales en distintas áreas, las cuales trimestral y anualmente deben realizar sus declaraciones.",
        isOpen: false
      },
      {
        id: 3,
        question: "¿Cómo puedo contratar sus servicios?",
        answer: "Nos pueden contactar por medio de nuestras redes sociales y/o solicitando información a info@akigreen.com.",
        isOpen: false
      },
      {
        id: 4,
        question: "¿Ofrecen capacitación en manejo de residuos a sus clientes?",
        answer: "Tenemos el servicio de Capacitación donde abarcamos cómo debe ser las rutas y el manejo de los residuos en su centro médico para un mayor entendimiento de tu equipo de trabajo.",
        isOpen: false
      }
    ]
  },
  contact: {
    ctaText: "Agenda una cita",
    ctaUrl: "https://wa.link/unxfc0",
    phone1: "+51 972 424 771",
    phone2: "+51 980 997 849",
    emails: [
      {
        id: "1",
        email: "info@akigreen.com"
      },
      {
        id: "2",
        email: "ventas@akigreen.com"
      }
    ],
    address: "Av. Raúl Ferrero 1280. La Molina. Lima. Perú",
    social: [
      {
        id: "0",
        link: "https://www.facebook.com/profile.php?id=61557510952384&locale=es_LA",
        iconUrl: "img/facebook.png"
      },
      // {
      //   id: "1",
      //   link: "https://twitter.com",
      //   iconUrl: "img/gorjeo.png"
      // },
      {
        id: "2",
        link: "https://www.instagram.com/akigreen_peru/",
        iconUrl: "img/instagram.png"
      }
    ]
  },
  footer: {
    company: "AKIGREEN",
    year: "2024",
    copyright: "Todos los derechos reservados",
    devCompany: ".",
    devUrl: ""
  }
}

export default data;